import { Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';

// Configs
import {
  DEFAULT_PROCESS_ID_CONSTANT,
  DISPERSION_METHOD_COMPONENTS_CONSTANT,
  DISPERSION_METHOD_STATE_ENUMERATION,
} from '../configs';

// Models
import { DispersionMethodStrategyType } from '../models';
import { ProductType } from '@core/model/enums';

// Shared
import { ROUTES_CONSTANTS } from '@shared/configs';
import { MarketingEventEnumeration, MarketingEventService, RecurrentStatesEnumeration } from '@shared/services';

export const RP_DISPERSION_METHOD_STRATEGY = ({ injector }: { injector: Injector }): DispersionMethodStrategyType => {
  const ngZone = injector.get(NgZone);
  const router = injector.get(Router);
  const marketingEventService = injector.get(MarketingEventService);

  return {
    processId: DEFAULT_PROCESS_ID_CONSTANT,
    productId: ProductType.RP,
    viewName: DISPERSION_METHOD_COMPONENTS_CONSTANT.VERIFICATION_SELECT_ACCOUNT,
    finalProcessFunc: ({ state, args }) => {
      ngZone.run(() => {
        let clientType: string | undefined;
        let generateCard: boolean = false;

        if (args) {
          const { clientType: argsClientType, generateCard: argsGenerateCard } = args as {
            clientType?: string;
            generateCard: boolean;
          };
          clientType = argsClientType;
          generateCard = argsGenerateCard;
        }

        if (state === DISPERSION_METHOD_STATE_ENUMERATION.APPROVED && !generateCard) {
          const eventName =
            clientType === RecurrentStatesEnumeration.IS_RECURRING
              ? MarketingEventEnumeration.RECURRENT_APPROVED_RP
              : MarketingEventEnumeration.NEW_APPROVED_RP;
          marketingEventService.sendMarketingEvents(eventName);

          router.navigate([ROUTES_CONSTANTS.SIGN_APPLICATION]);
        } else if (
          state === DISPERSION_METHOD_STATE_ENUMERATION.DECLINED ||
          state === DISPERSION_METHOD_STATE_ENUMERATION.CANCELED ||
          state === DISPERSION_METHOD_STATE_ENUMERATION.GRAY_ZONE
        ) {
          router.navigate([ROUTES_CONSTANTS.HOME]);
        } else {
          router.navigate([ROUTES_CONSTANTS.CARD_ONBOARDING]);
        }
      });
    },
  };
};
